import { ActionTree } from 'vuex';
import { RootState } from '@/models/states/root-state.model';
import { FiltersEvents, FiltersEventsState } from '@/models/states/filters-state.model';

export const actions: ActionTree<FiltersEventsState, RootState> = {
  updateFilters({ commit }, payload: FiltersEvents): any {
    commit('onUpdateFilters', payload);
  },
};
